import React from 'react';
import {
  Alert,
  Box,
  Button,
  Divider,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import RouteOutlinedIcon from '@mui/icons-material/RouteOutlined';

import { IJourneyPanelProps } from './PlanningControlCenter.types';

export default class PlanningJourneyPanel extends React.PureComponent<
  IJourneyPanelProps
> {
  render(): React.ReactNode {
    const { busy, onGenerate } = this.props;

    const journey = [...this.props.journey]
      .filter((step) => step.enb === 1)
      .sort((a, b) => a.pho - b.pho);

    return (
      <Stack spacing={2}>
        <Box>
          <Button
            variant="contained"
            startIcon={<RouteOutlinedIcon />}
            disabled={busy}
            onClick={onGenerate}
          >
            Generate Journey
          </Button>
        </Box>

        {journey.length === 0 ? (
          <Alert severity="info">
            Generate the journey after Planning Policies are established.
          </Alert>
        ) : (
          journey.map((step, index) => (
            <React.Fragment key={step.rid}>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography variant="caption" color="text.secondary">
                  Step {index + 1}
                </Typography>
                <Typography fontWeight={700}>{step.phn}</Typography>
                {step.dsc ? (
                  <Typography variant="body2" color="text.secondary">
                    {step.dsc}
                  </Typography>
                ) : null}
              </Paper>
              {index < journey.length - 1 ? <Divider /> : null}
            </React.Fragment>
          ))
        )}
      </Stack>
    );
  }
}
